import React, { ReactNode } from "react";

type Props = {
  header: {
    title: string;
    key: string;
    /** right-align this column and its cells, per the reference's numeric rule */
    numeric?: boolean;
  }[];
  column: (string | React.JSX.Element | null)[][] | undefined;
  label?: string;
  eyebrow?: string;
  actions?: ReactNode;
  display?: boolean;
  defaultDisplay?: ReactNode;
};

const Table = ({
  header,
  column,
  label,
  eyebrow,
  actions,
  display,
  defaultDisplay,
}: Props) => {
  const isEmpty = column?.length === 0 || display;

  return (
    <div className="overflow-hidden rounded-2xl border bg-card shadow-ui-sm">
      {(label || actions) && (
        <div className="flex items-start justify-between gap-4 border-b px-4 py-4">
          <div className="min-w-0">
            {eyebrow && (
              <div className="text-[11px] font-semibold uppercase tracking-wider text-brand-orange">
                {eyebrow}
              </div>
            )}
            {label && (
              <h2 className="truncate font-display text-base font-bold text-brand-navy">
                {label}
              </h2>
            )}
          </div>
          {actions && (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          )}
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-surface text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <tr>
              {header?.map((item) => (
                <th
                  scope="col"
                  className={`whitespace-nowrap px-4 py-3 ${
                    item.numeric ? "text-right" : ""
                  }`}
                  key={item.key}
                >
                  {item.title}
                </th>
              ))}
            </tr>
          </thead>
          {!isEmpty && (
            <tbody className="divide-y">
              {column?.map((row, i) => (
                <tr className="transition-colors hover:bg-surface/60" key={i}>
                  {row?.map((item, index) => (
                    <td
                      className={`whitespace-nowrap px-4 py-3 align-middle text-brand-navy ${
                        header?.[index]?.numeric ? "text-right tabular-nums" : ""
                      }`}
                      key={index}
                    >
                      {item}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>

      {isEmpty && <div className="p-4">{defaultDisplay}</div>}
    </div>
  );
};

export default Table;